import { Button, Card, CardBody, EmptyState } from '@bifeai/ui';
import { Compass } from 'lucide-react';
import { useNavigate } from 'react-router';

export function NotFoundPage() {
  const navigate = useNavigate();
  return (
    <Card>
      <CardBody>
        <EmptyState
          icon={<Compass />}
          title="Esta sección no existe"
          text="Puede que el enlace esté mal escrito o que la sección todavía no esté disponible."
          action={
            <Button variant="primary" onClick={() => navigate('/')}>
              Ir al dashboard
            </Button>
          }
        />
      </CardBody>
    </Card>
  );
}
